export default __webpack_public_path__ + "static/media/speaker11.18e4ed79.png";